import { ISubscription } from 'models/subscriptions.model'

import { getAxonItem } from './getAxonItem'

export const getAxonCheckoutParams = (selectedSubscription: ISubscription) => ({
  currency: selectedSubscription.currency.toUpperCase(),
  value:
    selectedSubscription.trialPrices?.fullPrice ||
    selectedSubscription.mainPrices?.fullPrice,
  items: getAxonItem([selectedSubscription]),
})
